module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_DE_LAT.7cda57dd.pdf";